import React from "react";

function CartItemsinCheckout({ item }) {
  const image = item.thumbnail;
  const title = item.title;
  const variantName = item.variantName;
  const quantity = item.quantity;
  const mrp = item.mrp;
  const subtotal = item.subtotal;

  const price = item?.price.toFixed(2);

  return (
    <li className="order-item">
     
      <div className="content d-flex">
         <img src={image} alt="product"  className="cart-item-img-checkout" />
        <div className="text-white opacity-75 info p-2">
          <p className="name text-white opacity-75 text-sm fw-medium">{title}</p>
          <span className="variant">{variantName}</span>
          <span className="variant">
            Qty: <b>{quantity}</b>
          </span>
        </div>
        
      </div>
      <span className="price text-sm fw-medium">
          {/* <span className="price text-white text-sm fw-medium">₹{price}/-</span> */}

          {!isNaN(mrp) && mrp > price && (
            <span className="old-price text-decoration-line-through text-white opacity-75 p-2">
              ₹{mrp.toFixed(2)}/-
            </span>
          )}

          <span className="price text-sm fw-medium text-white">₹{subtotal}/-</span>
        </span>
    </li>
  );
}

export default CartItemsinCheckout;
